import React from "react";
import "../style/contact.css";

import role from "../assets/role.png";
import joblocation from "../assets/joblocation.png";
import message from "../assets/message.png";
import call from "../assets/call.png";
import placemarker from "../assets/placemarker.png";
import clock from "../assets/clock.png";
import ContactForm from "./ContactForm";

export const Contact = () => {
  return (
    <div>
      <section className="contact-section1">
        <h1>Contact Us</h1>
        <span>
          Get in touch to learn more about our services or to begin the journey
          of finding the right care solution.
        </span>
      </section>
      <section className="contact-section2">
        <div className="contact-section2-div1">
          <h3>Get In Touch</h3>
          <p>
            We're here to answer your questions, provide information about our
            services, and support you through the care placement process.
          </p>
          <span className="contact-section2-div1-span1">
            <img
              src={message}
              alt="message"
              loading="lazy"
              style={{ width: "55px", height: "50px" }}
            />
            <span>
              Email Us
              <br /> info@serenityresidentialcare.co.uk
              <br /> We respond within 24 hours
            </span>
          </span>
          <span className="contact-section2-div1-span1">
            <img
              src={call}
              alt="call"
              loading="lazy"
              style={{ width: "55px", height: "50px" }}
            />
            <span>
              Phone
              <br /> 0121 769 3243
            </span>
          </span>
          <span className="contact-section2-div1-span1">
            <img
              src={placemarker}
              alt="placemarker"
              loading="lazy"
              style={{ width: "55px", height: "50px" }}
            />
            <span>
              Address
              <br /> 43 Vincent Street,
              <br /> Birmingham, UK, B12 9TP
            </span>
          </span>
          <span className="contact-section2-div1-span1">
            <img
              src={clock}
              alt="clock"
              loading="lazy"
              style={{ width: "55px", height: "50px" }}
            />
            <span>
              Office Hours
              <br /> Monday - Friday: 9:00 AM - 5:00pm <br />
              Saturday: Emergency calls only
              <br /> Sunday: Emergency calls only
            </span>
          </span>
        </div>
        <div id="contact-section2-div2" className="contact-section2-div2">
          <ContactForm />
        </div>
      </section>
      <section className="contact-section3">
        <h1>Join Our Team</h1>
        <div className="contact-section3-div1">
          <div className="contact-section3-div1-item">
            <h1>Team Lead</h1>
            <span>
              <img src={role} alt="role" loading="lazy" />
              <img src={joblocation} alt="joblocation" loading="lazy" />
            </span>
            <p>
              Experienced care assistant to join our
              <br /> dedicated team. NVQ Level 3 in
              <br /> Health & Social Care required.
            </p>
            <h3>Requirements:</h3>
            <ul>
              <li>NVQ Level 3 in health and social care</li>
              <li>2+ years experience in senior role</li>
              <li> Excellent communication skills</li>
            </ul>
            <div className="section3-link">
              <a href="#contact-section2-div2">Apply Now</a>
            </div>
          </div>
          <div className="contact-section3-div1-item">
            <h1>Day Support Worker</h1>
            <span>
              <img src={role} alt="role" loading="lazy" />
              <img src={joblocation} alt="joblocation" loading="lazy" />
            </span>
            <p>
              Support worker for day shifts.
              <br /> Experience required.
            </p>
            <h3>Requirements:</h3>
            <ul>
              <li>NVQ Level 2 in health and social care</li>
              <li>2+ years experience in senior role </li>
              <li>Excellent communication skills</li>
            </ul>
            <div className="section3-link">
              <a href="#contact-section2-div2">Apply Now</a>
            </div>
          </div>
          <div className="contact-section3-div1-item">
            <h1>Night Support Worker</h1>
            <span>
              <img src={role} alt="role" loading="lazy" />
              <img src={joblocation} alt="joblocation" loading="lazy" />
            </span>
            <p>
              Support worker for night shifts.
              <br /> Experience required.
            </p>
            <h3>Requirements:</h3>
            <ul>
              <li>NVQ Level 2 in health and social care</li>
              <li>2+ years experience in senior role</li>
              <li> Excellent communication skills</li>
            </ul>
            <div className="section3-link">
              <a href="#contact-section2-div2">Apply Now</a>
            </div>
          </div>
        </div>
        <div className="contact-section3-div2">
          <h3>Don't See a Suitable Position?</h3>
          <span>
            We're always interested in hearing from passionate care
            professionals.
            <br /> Send us your CV and we'll keep you in mind for future
            opportunities.
          </span>
          <div className="section3-link">
            <a href="#contact-section2-div2">Apply Now</a>
          </div>
        </div>
      </section>
      <section className="contact-section4">
        <div className="contact-section4-div1">
          <h1>Emergency Contact</h1>
          <h3>
            For urgent care needs or emergency placement requests, our team is
            <br />
            available 24/7 to provide immediate assistance.
          </h3>
          <p>
            <span>Tel:</span>
            <a href="tel:+[234][81313843]" className="footer-link">
              Emergency Hotline: 0121 769 3243
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};
